import {ExternalLinksLegacyStrategy} from "./external-links-legacy.strategy";
import {MarketingParams} from "../../../../common/interfaces/marketing-params.interface";
import {IExternalLinksHandlersFactory} from "../handlers-factory/external-links-handlers-factory.interface";
import {IOpenMyAccountOptions} from "../handlers/my-account/my-account.external-link-handler.interface";
import {OpenLinkParams, OpenMembershipResponse} from "../external-links.service.interface";
import {IOpenRegistrationOptions} from "../handlers/registration/registration.external-link-handler.interface";

const UseModernStrategy = {
    forMyAccount: true,
    forRegistration: true
}

export class ExternalLinksModernStrategy extends ExternalLinksLegacyStrategy {

    private get _handlers(): IExternalLinksHandlersFactory {
        return this.services.regulation.current.externalLinks;
    }


    openMyAccount(options?: IOpenMyAccountOptions, marketingParams?: MarketingParams): Promise<void> {
        if(UseModernStrategy.forMyAccount) {
            return this._handlers.myAccount.openMyAccount(options);
        }

        return super.openMyAccount(options);
    }

    async openMembership(options?: IOpenRegistrationOptions): Promise<OpenMembershipResponse> {
        if(UseModernStrategy.forRegistration) {
            await this._handlers.registration.openRegistration(options);
            return OpenMembershipResponse.close;
        }

        return await super.openMembership(options);
    }

    openLink(params: OpenLinkParams, marketingParams?: MarketingParams, useCallbackURL: boolean = false): Promise<any> {
        if(params.source === 'membership' && UseModernStrategy.forRegistration) {
            return this.openMembership({
                marketingParams: marketingParams
            });
        }
        return super.openLink(params, marketingParams, useCallbackURL);
    }

}